import * as Yup from "yup";

export const initialValues = {
  title: "",
  industry: "",
  startDate: "",
  endDate: "",
  companyName: "",
  companyRole: [],
  Projectsnippet: "",
  description: "",
  multiFiles: [],
  workExperienceList: "",
  employmentType: "",
};

export const validationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  industry: Yup.string().notRequired(),
  startDate: Yup.date().required("Start Date is required"),
  endDate: Yup.date().required("End Date is required"),
  companyName: Yup.string().required("Company Name is required"),
  companyRole: Yup.array().notRequired(),
  Projectsnippet: Yup.string().notRequired(),
  description: Yup.string().required("Description is required"),
  multiFiles: Yup.array().notRequired(),
  workExperienceList: Yup.string().notRequired(),
  employmentType: Yup.string().required("Employment Type is required"),
});
